import axios, { type AxiosError } from "axios";

import type { UsersAPI } from "generated/types";
import { type ApiRequestError, RequestError } from "models/error/Error";

import { ERROR_TYPES } from "constants/error-constants";

import cookieStorage from "persistence";
import { handlingResponse, logError } from "repositories/utils";

const fetchEmailInviteBundleDetails = async (
  emailInviteBundleId: string,
): Promise<UsersAPI.EmailInviteBundleDetails> => {
  try {
    const response = await axios.get(`/api/invite/email-bundle/${emailInviteBundleId}`, {
      headers: { Authorization: cookieStorage.getToken() },
    });
    return handlingResponse<UsersAPI.EmailInviteBundleDetails>(
      [200],
      "Error fetching email invite bundle details",
    )(response);
  } catch (error) {
    const { message, status, errCode } = logError(error as AxiosError<ApiRequestError>);
    throw new RequestError({
      message,
      status,
      errCode,
      type: ERROR_TYPES.GET_EMAIL_INVITE_BUNDLE_DETAILS_FAILED,
    });
  }
};

export { fetchEmailInviteBundleDetails };
